import { render, staticRenderFns } from "./OpcionesChat.vue?vue&type=template&id=61b570fa"
import script from "./OpcionesChat.vue?vue&type=script&lang=js"
export * from "./OpcionesChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports